import { AdminRepo, AdminApi } from "common/helpers/admin-page-class"

import { CompaniesApi } from "common/api"
import { filterCompanies, sortCompanies } from "./utils"

const organizer = {
  filter: filterCompanies,
  sort: sortCompanies
}
const repo = new AdminRepo(organizer)

const http = {
  get: CompaniesApi.get,
  create: CompaniesApi.create,
  update: CompaniesApi.update,
  remove: CompaniesApi.remove
}
const api = new AdminApi(http, repo)

const methods = {
  get: api.get.bind(api),
  create: api.create.bind(api),
  update: api.update.bind(api),
  remove: api.remove.bind(api)
}

export { methods as CompaniesApi }
